import React from "react"
import { useSelector } from "react-redux"
import { attachmentCount } from "reduxSlices/formSubmissionSlice"
import { CountBadge } from "components/shared/badges"

const AttachmentsCountBadge = () => {
  const count = useSelector(attachmentCount)

  return count ? <CountBadge count={count} /> : null
}

export default AttachmentsCountBadge
